'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _Dropdown = require('../../blocks/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = require('./constants');

var _Action = require('./Action');

var _Action2 = _interopRequireDefault(_Action);

var _Content = require('./Content');

var _Content2 = _interopRequireDefault(_Content);

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Target = require('./Target');

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeItem: _this.props.activeItem,
      showContent: _this.props.showContent
    }, _this.setInnerRef = function (node) {
      _this.innerRef = node;
      return _this.innerRef;
    }, _this.handleClickOutside = function (e) {
      if (!_this.innerRef.contains(e.target) && _this.state.showContent) {
        _this.toggleContent({ show: false });
      }
    }, _this.handleHover = function () {
      if (_this.props.showOnHover) {
        _this.toggleContent({ show: true });
      }
    }, _this.toggleContent = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          show = _ref2.show;

      if (_this.props.readOnly) {
        return undefined;
      }

      // this allows us to handle all show / hide logic in a single location
      // you can explicitly tell the content to show / hide, or let it toggle.
      if (show !== undefined) {
        _this.props.onExpandedChange(show);
        return _this.setState({ showContent: show });
      }

      _this.props.onExpandedChange(!_this.state.showContent);
      return _this.setState({ showContent: !_this.state.showContent });
    }, _this.showContent = function () {
      return _this.toggleContent({ show: true });
    }, _this.hideContent = function () {
      return _this.toggleContent({ show: false });
    }, _this.handleItemClick = function (e, itemId) {
      _this.props.onChange(e, itemId);
      if (_this.props.hideOnChange) {
        _this.toggleContent({ show: false });
        return _this.setState({ activeItem: itemId });
      }
      return _this.setState({ activeItem: itemId });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, _constants.DROPDOWN_CONTEXT, {
        activeItem: this.state.activeItem,
        arrow: this.props.arrow,
        fullWidth: this.props.fullWidth,
        handleHover: this.handleHover,
        handleItemClick: this.handleItemClick,
        handleToggle: this.toggleContent,
        hideContent: this.hideContent,
        position: this.props.position,
        readOnly: this.props.readOnly,
        removeOnHide: this.props.removeOnHide,
        selectable: this.props.selectable,
        showContent: this.state.showContent,
        zIndex: this.props.zIndex
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.activeItem !== nextProps.activeItem) {
        this.setState({ activeItem: nextProps.activeItem });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          position = _props.position,
          rest = _objectWithoutProperties(_props, ['children', 'position']);

      return _react2.default.createElement(
        _Dropdown2.default,
        _extends({
          innerRef: this.setInnerRef,
          modifiers: [position]
        }, rest),
        (0, _lodash.isFunction)(children) ? children({
          show: this.showContent,
          hide: this.hideContent,
          toggle: this.toggleContent,
          isVisible: this.state.showContent
        }) : children
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.Action = _Action2.default;
Dropdown.Content = _Content2.default;
Dropdown.Divider = _Dropdown2.default.Divider;
Dropdown.List = _List2.default;
Dropdown.ListItem = _Dropdown2.default.ListItem;
Dropdown.SectionHeader = _Dropdown2.default.SectionHeader;
Dropdown.SectionBody = _Dropdown2.default.SectionBody;
Dropdown.Target = _Target2.default;
Dropdown.modifiers = _Dropdown2.default.modifiers;
Dropdown.childContextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);
Dropdown.propTypes = {
  activeItem: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object]),
  arrow: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired,
  fullWidth: _propTypes2.default.bool,
  hideOnChange: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onExpandedChange: _propTypes2.default.func,
  position: _propTypes2.default.oneOf(['bottom', 'bottomLeft', 'bottomRight']),
  readOnly: _propTypes2.default.bool,
  removeOnHide: _propTypes2.default.bool,
  selectable: _propTypes2.default.bool,
  showContent: _propTypes2.default.bool,
  showOnHover: _propTypes2.default.bool,
  zIndex: _propTypes2.default.number
};
Dropdown.defaultProps = {
  activeItem: '',
  arrow: false,
  fullWidth: false,
  hideOnChange: false,
  onChange: _lodash.noop,
  onExpandedChange: _lodash.noop,
  position: 'bottom',
  readOnly: false,
  removeOnHide: true,
  selectable: true,
  showContent: false,
  showOnHover: false,
  zIndex: 1
};
exports.default = Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Dropdown/index.js
// module id = 1643
// module chunks = 2